module.exports = __webpack_public_path__ + "img/XK.3d63460e.png";